import { request, config } from '@/lib';
import Top from './components/top';
import Category from './components/category';
import Nearby from './components/nearby';
import Pk from './components/pk';
import Main from './components/main';
import { useSetState, useStateful } from 'react-hanger';
import { useEffect } from 'react';
import Head from 'next/head';
import util from './util';

import homeStyle from './static/styles/index.module.scss';
import { LoadingBlock } from 'components';
import Index from 'modules/family';
const a = homeStyle.a;

const Home = () => {
  const { state, setState } = useSetState(null);

  const reqConfig = {
    room_list: {
      // ****** 此数据 直播间也有用到 ！！！！ 更新请注意  ********
      url: '/api/v3/hot/room_list?live_type=0&offset=0&limit=48',
      host: 'cryolite',
    },
    new_room_list: {
      url: 'api/v3/hot/room_list?live_type=0&offset=0&limit=24&filter=3',
      host: 'cryolite',
    },
    recent_room_list: {
      url: 'api/v3/hot/room_list?live_type=0&offset=0&limit=24&filter=2',
      host: 'cryolite',
    },
    mobile_room_list: {
      url: 'api/v3/hot/room_list?live_type=2&offset=0&limit=24&filter=0',
      host: 'cryolite',
    },
    recommend_data: {
      url: 'api/v5/homes',
      host: 'cryolite',
    },
    nvshen: {
      url: '/api/v3/labels/36/stars?offset=0&limit=4',
      host: 'cryolite',
    },
    haoshengyin: {
      url: '/api/v3/labels/35/stars?offset=0&limit=4',
      host: 'cryolite',
    },
    rewu: {
      url:
        config.production || config.grey
          ? '/api/v3/labels/33/stars?offset=0&limit=4'
          : '/api/v3/labels/42/stars?offset=0&limit=4',
      host: 'cryolite',
    },
    pk_list: {
      url: 'api/v2/lian_mai/rooms',
      host: 'cryolite',
    },

    notice: { url: 'public/notice?size=4' },
    poster: { url: 'public/poster' },
    user_day: { url: 'rank/user_day/5' },
    user_week: { url: 'rank/user_week/5' },
    star_day: { url: 'rank/star_day/5' },
    star_week: { url: 'rank/star_week/5' },
  };

  const loadData = (key, opt) => {
    return request[opt.host || 'api'].get(opt.url);
  };

  useEffect(() => {
    const loadAllData = async () => {
      const reqs = Object.keys(reqConfig);
      const data = {};
      Promise.all(
        reqs.map((key) => {
          return loadData(key, reqConfig[key]);
        }),
      ).then((res) => {
        console.log('all data res', res);
        res.map((item, index) => {
          data[reqs[index]] =
            res[index].data?.data?.items ||
            res[index].data?.items ||
            res[index].data;
        });

        data.top_list = util
          .fakeListVisiterCount(data.recommend_data.recommed_rooms)
          .map((item) => {
            if (item.from && item.from === 'guanfang') {
              if (item.current_star_id) {
                item.videoRoomId = item.current_star_id;
              }
            }
            return item;
          })
          .filter((item) => {
            if (item.from && item.from === 'guanfang') {
              return item.show_banner;
            }
            return true;
          });

        data.room_list = util.fakeListVisiterCount(data.room_list);
        data.new_room_list = util.fakeListVisiterCount(data.new_room_list);
        data.recent_room_list = util.fakeListVisiterCount(
          data.recent_room_list,
        );
        data.mobile_room_list = util.fakeListVisiterCount(
          data.mobile_room_list,
        );
        data.nvshen = util.fakeListVisiterCount(data.nvshen);
        data.rewu = util.fakeListVisiterCount(data.rewu);
        data.haoshengyin = util.fakeListVisiterCount(data.haoshengyin);
        // data.voice = fakeListVisiterCount(data.voice.items);
        data.pk_list = util.changePkListPic(data.pk_list);

        setState(data);
        console.log('all data', data);

        import('./static/index').then(() => {
          setTimeout(() => {
            MM.index.main.init();
          }, 100);
        });
      });
    };

    loadAllData();
  }, []);

  if (!state) {
    return <LoadingBlock page></LoadingBlock>;
  }

  return (
    <div>
      <Head>
        <script
          dangerouslySetInnerHTML={{
            __html: `var ROOM_FOUND_LATEST = ${JSON.stringify(
              state.top_list,
            )};`,
          }}
        ></script>
      </Head>
      <Top top_list={state.top_list}></Top>
      <Category data={state}></Category>
      {/*<Nearby></Nearby>*/}
      <Pk data={state}></Pk>
      <Main data={state}></Main>
    </div>
  );
};

Home.getInitialProps = async (ctx) => {
  return {
    currentPage: 'index',
  };
};
export default Home;
